import { Action } from "redux"

import * as actions from "./actions"
import { IContracts } from "./index"

export const initialState: IContracts = {
    contracts: [],
    settings: undefined,
    editor: {
        visible: false,
        contract: undefined,
    },
    report: {
        visible: false,
        data: undefined,
    },
}

const handlers: {
    [action: string]: (state: IContracts, props: Action) => IContracts
} = {
    [actions.SET_INITIALIZED]: (state): IContracts => ({
        ...state,
        initialized: true,
    }),

    [actions.REQUEST_CONTRACTS]: (state): IContracts => ({
        ...state,
        validating: true,
    }),

    [actions.RECEIVE_CONTRACTS]: (
        state,
        { contracts }: actions.ReceiveContracts,
    ): IContracts => ({ ...state, contracts, validating: false }),

    [actions.RECEIVE_CONTRACT]: (
        state,
        { contract }: actions.ReceiveContract,
    ): IContracts => ({
        ...state,
        editor: { visible: true, contract },
    }),

    [actions.CLOSE_EDITOR]: (state): IContracts => ({
        ...state,
        editor: { visible: false, contract: undefined },
    }),

    [actions.RECEIVE_GLOBAL_SETTINGS]: (
        state,
        { settings }: actions.GlobalSettings,
    ): IContracts => ({ ...state, settings }),

    [actions.RECEIVE_REPORT]: (
        state,
        { data }: actions.ReceiveReport,
    ): IContracts => ({ ...state, report: { visible: true, data } }),

    [actions.CLOSE_REPORT]: (state): IContracts => ({
        ...state,
        report: { visible: false, data: undefined },
    }),
}

export default function reducer(
    state: IContracts = initialState,
    action: Action,
): IContracts {
    const handler: (state: IContracts, action: Action) => IContracts =
        handlers[action.type]
    return handler ? handler(state, action) : state
}
